import { render } from "./GroupManagementWorkDaysDialog.vue?vue&type=template&id=3d0ffd70"
import script from "./js/groupManagementWorkDaysDialog.js?vue&type=script&lang=js&external"
export * from "./js/groupManagementWorkDaysDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__